<template>
    <div class="control-row">
        <div class="control-buttons">
            <!-- Skip previous -->
            <button
                class="control-btn"
                :disabled="!hasPrevious"
                @click="$emit('skip-prev')"
            >
                <font-awesome-icon icon="backward-step" />
            </button>

            <!-- Seek back 5s -->
            <button
                class="control-btn"
                :title="$t('video_recordings.seek_back_5s')"
                :aria-label="$t('video_recordings.seek_back_5s')"
                @click="$emit('seek-by', -5)"
            >
                <font-awesome-icon icon="rotate-left" />
            </button>

            <!-- Play / Pause -->
            <button
                class="control-btn"
                :class="{ active: isPlaying }"
                @click="isPlaying ? $emit('pause') : $emit('play')"
            >
                <font-awesome-icon :icon="isPlaying ? 'pause' : 'play'" />
            </button>

            <!-- Seek forward 5s -->
            <button
                class="control-btn"
                :title="$t('video_recordings.seek_forward_5s')"
                :aria-label="$t('video_recordings.seek_forward_5s')"
                @click="$emit('seek-by', 5)"
            >
                <font-awesome-icon icon="rotate-right" />
            </button>

            <!-- Skip next -->
            <button
                class="control-btn"
                :disabled="!hasNext"
                @click="$emit('skip-next')"
            >
                <font-awesome-icon icon="forward-step" />
            </button>
        </div>

        <!-- Playback speed -->
        <div class="dropdown">
            <button
                class="control-btn dropdown-toggle"
                data-bs-toggle="dropdown"
            >
                {{ playbackRate }}x
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
                <li
                    v-for="rate in rates"
                    :key="rate"
                >
                    <a
                        class="dropdown-item"
                        :class="{ active: playbackRate === rate }"
                        href="#"
                        @click.prevent="$emit('speed-change', rate)"
                    >
                        {{ rate }}x
                    </a>
                </li>
            </ul>
        </div>

        <button
            class="btn btn-success form-button ms-auto"
            @click="$emit('create-observation')"
        >
            {{ $t('observations.add_new') }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'VideoControls',
    props: {
        isPlaying: {
            type: Boolean,
            default: false
        },
        playbackRate: {
            type: Number,
            default: 1
        },
        hasPrevious: {
            type: Boolean,
            default: false
        },
        hasNext: {
            type: Boolean,
            default: false
        }
    },
    emits: ['play', 'pause', 'skip-next', 'skip-prev', 'seek-by', 'speed-change', 'create-observation'],
    data() {
        return {
            rates: [0.5, 1, 1.5, 2, 4]
        }
    }
}
</script>

<style scoped>
.control-row {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
}

.control-buttons {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.control-btn {
    min-width: 40px;
    height: 40px;
    border: none;
    border-radius: 8px;
    background: #f8f9fa;
    color: #333;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    font-size: 0.8rem;
    padding: 0 12px;
}

.control-btn:hover {
    background: #e9ecef;
}

.control-btn:disabled {
    opacity: 0.5;
    cursor: default;
}

.control-btn:disabled:hover {
    background: #f8f9fa;
}

.control-btn.active {
    background: #7FC000;
    color: white;
}
</style>
